var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlowersRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 72,
    viewBox: "0 0 144 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14512_14052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.954 50.6742C104.809 51.0188 104.43 51.1881 104.108 51.0523C103.785 50.9166 103.642 50.5272 103.787 50.1826C103.932 49.838 104.311 49.6686 104.633 49.8044C104.956 49.9401 105.099 50.3295 104.954 50.6742Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.954 50.6742C104.809 51.0188 104.43 51.1881 104.108 51.0523C103.785 50.9166 103.642 50.5272 103.787 50.1826C103.932 49.838 104.311 49.6686 104.633 49.8044C104.956 49.9401 105.099 50.3295 104.954 50.6742Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.691 23.9312C127.604 24.1389 127.375 24.2409 127.181 24.1591C126.987 24.0773 126.9 23.8426 126.987 23.6349C127.075 23.4272 127.303 23.3251 127.498 23.4069C127.692 23.4888 127.779 23.7235 127.691 23.9312Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.691 23.9312C127.604 24.1389 127.375 24.2409 127.181 24.1591C126.987 24.0773 126.9 23.8426 126.987 23.6349C127.075 23.4272 127.303 23.3251 127.498 23.4069C127.692 23.4888 127.779 23.7235 127.691 23.9312Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.983 22.2083C104.838 22.5529 104.459 22.7223 104.136 22.5865C103.814 22.4508 103.67 22.0614 103.815 21.7167C103.961 21.3721 104.339 21.2028 104.662 21.3386C104.984 21.4743 105.128 21.8637 104.983 22.2083Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.983 22.2083C104.838 22.5529 104.459 22.7223 104.136 22.5865C103.814 22.4508 103.67 22.0614 103.815 21.7167C103.961 21.3721 104.339 21.2028 104.662 21.3386C104.984 21.4743 105.128 21.8637 104.983 22.2083Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.374 69.7226C134.168 64.896 129.595 57.8688 127.513 49.9785",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.374 69.7226C134.168 64.896 129.595 57.8688 127.513 49.9785",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.948 63.1832C129.831 62.4964 120.167 53.4062 121.092 42.9581C121.741 35.6037 127.15 35.8587 130.117 40.9317C131.689 43.6161 132.904 48.4446 133.173 52.6132C133.459 57.1006 133.726 59.7086 133.942 61.3191C134.135 62.7388 133.948 63.1832 133.948 63.1832Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.948 63.1832C129.831 62.4964 120.167 53.4062 121.092 42.9581C121.741 35.6037 127.15 35.8587 130.117 40.9317C131.689 43.6161 132.904 48.4446 133.173 52.6132C133.459 57.1006 133.726 59.7086 133.942 61.3191C134.135 62.7388 133.948 63.1832 133.948 63.1832Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.476 71.1757C122.715 70.4089 118.151 66.7364 118.641 64.4773C119.131 62.2182 122.59 61.5612 127.231 66.9064C131.872 72.2516 130.686 71.6919 127.476 71.1757Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.476 71.1757C122.715 70.4089 118.151 66.7364 118.641 64.4773C119.131 62.2182 122.59 61.5612 127.231 66.9064C131.872 72.2516 130.686 71.6919 127.476 71.1757Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.341 66.708C123.341 66.708 131.907 72.6592 135.185 74.3109",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.341 66.708C123.341 66.708 131.907 72.6592 135.185 74.3109",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.316 54.3531C113.49 54.3086 112.481 51.8514 113.578 51.5486C115.691 50.9588 117.957 54.4085 115.316 54.3531Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.316 54.3531C113.49 54.3086 112.481 51.8514 113.578 51.5486C115.691 50.9588 117.957 54.4085 115.316 54.3531Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.594 46.4668C108.481 45.2969 106.88 38.857 109.988 39.9741C113.095 41.0912 116.012 48.1156 111.594 46.4668Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.594 46.4668C108.481 45.2969 106.88 38.857 109.988 39.9741C113.095 41.0912 116.012 48.1156 111.594 46.4668Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.629 49.9981C146.086 53.9643 143.573 56.267 142.564 55.8223C141.18 55.2194 142.029 50.5654 142.82 48.6645C143.611 46.7635 145.402 48.1215 145.629 49.9981Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.629 49.9981C146.086 53.9643 143.573 56.267 142.564 55.8223C141.18 55.2194 142.029 50.5654 142.82 48.6645C143.611 46.7635 145.402 48.1215 145.629 49.9981Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.446 69.5517C134.241 64.7251 129.668 57.6979 127.586 49.8076",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.446 69.5517C134.241 64.7251 129.668 57.6979 127.586 49.8076",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.016 63.0211C129.9 62.3343 120.236 53.2441 121.161 42.796C121.809 35.4416 127.219 35.6966 130.186 40.7696C131.758 43.454 132.973 48.2825 133.242 52.451C133.527 56.9385 133.794 59.5465 134.01 61.157C134.207 62.5681 134.016 63.0211 134.016 63.0211Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.016 63.0211C129.9 62.3343 120.236 53.2441 121.161 42.796C121.809 35.4416 127.219 35.6966 130.186 40.7696C131.758 43.454 132.973 48.2825 133.242 52.451C133.527 56.9385 133.794 59.5465 134.01 61.157C134.207 62.5681 134.016 63.0211 134.016 63.0211Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.548 71.0048C122.787 70.238 118.224 66.5655 118.713 64.3064C119.203 62.0473 122.662 61.3903 127.303 66.7355C131.944 72.0807 130.758 71.521 127.548 71.0048Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.548 71.0048C122.787 70.238 118.224 66.5655 118.713 64.3064C119.203 62.0473 122.662 61.3903 127.303 66.7355C131.944 72.0807 130.758 71.521 127.548 71.0048Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.413 66.5371C123.413 66.5371 131.979 72.4883 135.257 74.14",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.413 66.5371C123.413 66.5371 131.979 72.4883 135.257 74.14",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.388 54.1813C113.561 54.1368 112.553 51.6795 113.65 51.3767C115.763 50.7869 118.025 54.2452 115.388 54.1813Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.388 54.1813C113.561 54.1368 112.553 51.6795 113.65 51.3767C115.763 50.7869 118.025 54.2452 115.388 54.1813Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.666 46.2955C108.553 45.1256 106.953 38.6858 110.06 39.8028C113.163 40.9284 116.081 47.9528 111.666 46.2955Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.666 46.2955C108.553 45.1256 106.953 38.6858 110.06 39.8028C113.163 40.9284 116.081 47.9528 111.666 46.2955Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.697 49.8359C146.155 53.8022 143.641 56.1049 142.633 55.6602C141.249 55.0572 142.097 50.4032 142.888 48.5023C143.679 46.6014 145.474 47.9508 145.697 49.8359Z",
    stroke: "white",
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.697 49.8359C146.155 53.8022 143.641 56.1049 142.633 55.6602C141.249 55.0572 142.097 50.4032 142.888 48.5023C143.679 46.6014 145.474 47.9508 145.697 49.8359Z",
    stroke: "#821FFF",
    strokeOpacity: 0.6,
    strokeWidth: 0.994176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14512_14052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowersRight);
export default __webpack_public_path__ + "static/media/flowers_right.69d7620906b173ce86afb06cc6b76008.svg";
export { ForwardRef as ReactComponent };